import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class WebSocketService {
    private socket: WebSocket | null = null;
    private messageSubject = new BehaviorSubject<any>(null);
    private connectionStatus = new BehaviorSubject<boolean>(false);

    private audio: HTMLAudioElement;

    constructor(private route: Router) {
        this.audio = new Audio('assets/ringtone.mp3');
        this.audio.loop = true;
        this.audio.muted = true;   // preload silently
        this.audio.play().catch(() => {
            console.log('Autoplay prevented');
        }); // ignore autoplay error
    }

    connect(userData: any): void {
        if (this.socket) {
            this.socket.close();
        }

        const wsUrl = `${environment.wsUrl}?clientId=${userData._id}&type=agent&companyId=${userData.assignedCompany.id}&departmentId=${userData.assignedDepartmentRole[0].department}&userId=${userData._id}&role=${userData.role}`;

        console.log(wsUrl);

        this.socket = new WebSocket(wsUrl);

        this.socket.onopen = () => {
            console.log('WebSocket connection established');
            this.connectionStatus.next(true);
        };

        this.socket.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                // Handle new call notifications
                if (data.type === 'new_call') {
                    console.log('New call assigned:', data.data);
                    // Update UI or show notification
                    this.playRingtone();
                    Swal.fire({
                        title: 'New Call Assigned',
                        text: `You have been assigned a new call from ${data.data.customerName}.`,
                        icon: 'info',
                        showCancelButton: true,
                        confirmButtonText: 'Accept Call',
                        cancelButtonText: 'Dismiss'
                    }).then((result) => {
                        this.stopRingtone();
                        if (result.isConfirmed) {
                            // Logic to accept the call can be added here;
                            // route to call page, etc. 
                            this.route.navigate(['/pages/calling/support/', data.data.callId]);
                        } else {
                            console.log('Call Rejected');
                            this.sendCallEvent('call_rejected', data);
                        }
                    });
                }
                this.messageSubject.next(data);
            } catch (error) {
                console.error('Error parsing WebSocket message:', error);
            }
        };

        this.socket.onclose = () => {
            console.log('WebSocket connection closed');
            this.connectionStatus.next(false);
            // Attempt to reconnect after 5 seconds
            setTimeout(() => this.connect(userData), 5000);
        };

        this.socket.onerror = (error) => {
            console.error('WebSocket error:', error);
            this.connectionStatus.next(false);
        };
    }

    sendMessage(message: any): void {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(JSON.stringify(message));
        } else {
            console.error('WebSocket is not connected');
        }
    }

    sendCallEvent(eventType: string, callId: string): void {
        // this.sendMessage({ type: eventType, callId });
        this.socket?.send(JSON.stringify({ type: eventType, callId }));
    }

    disconnect(): void {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    }

    getMessages(): Observable<any> {
        return this.messageSubject.asObservable();
    }

    getConnectionStatus(): Observable<boolean> {
        return this.connectionStatus.asObservable();
    }

    isConnected(): boolean {
        return this.socket !== null && this.socket.readyState === WebSocket.OPEN;
    }

    playRingtone() {
        this.audio.muted = false; // unmute when needed
        this.audio.play();
    }

    stopRingtone() {
        this.audio.pause();
        this.audio.currentTime = 0;
    }
}
